import {
  Component,
  ElementRef,
  Input,
  QueryList,
  Renderer2,
  ViewChildren,
} from '@angular/core';
import { TUSpecial } from '../tu-special';

@Component({
  selector: 'app-tu-specials-table',
  templateUrl: './tu-specials-table.component.html',
  styleUrls: ['./tu-specials-table.component.scss'],
})
export class TUSpecialsTableComponent {
  @ViewChildren('sortIcons') sortIcons!: QueryList<ElementRef>;
  @Input('specials') specials: TUSpecial[] = [];

  page: number = 1;
  searchText: string = '';

  SortBySkuAsc: boolean = false;
  sortByDescriptionAsc: boolean = false;
  sortByClass2Asc: boolean = false;
  sortBySupplierSkuAsc: boolean = false;
  sortByOrderUnitAsc: boolean = false;
  sortBySupplierPriceAsc: boolean = false;
  sortBySalesPriceAsc: boolean = false;
  sortByDeliveryDaysAsc: boolean = false;
  sortByCreationByAsc: boolean = false;
  sortByCreationDateAsc: boolean = false;

  constructor(private renderer: Renderer2) {}

  sortByField(field: string, ascendingOrder: boolean) {
    switch (field) {
      case 'sku': {
        this.SortBySkuAsc = ascendingOrder;
        this.sortByDescriptionAsc = false;
        this.sortByClass2Asc = false;
        this.sortBySupplierSkuAsc = false;
        this.sortByOrderUnitAsc = false;
        this.sortBySupplierPriceAsc = false;
        this.sortBySalesPriceAsc = false;
        this.sortByDeliveryDaysAsc = false;
        this.sortByCreationDateAsc = false;
        this.sortByCreationByAsc = false;

        if (ascendingOrder) {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.description! < special2.description!) return -1;
            if (special1.description! > special2.description!) return 1;
            return 0;
          });
        } else {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.creationDate! < special2.creationDate!) return 1;
            if (special1.creationDate! > special2.creationDate!) return -1;
            return 0;
          });
        }
        break;
      }
      case 'description': {
        this.SortBySkuAsc = false;
        this.sortByDescriptionAsc = ascendingOrder;
        this.sortByClass2Asc = false;
        this.sortBySupplierSkuAsc = false;
        this.sortByOrderUnitAsc = false;
        this.sortBySupplierPriceAsc = false;
        this.sortBySalesPriceAsc = false;
        this.sortByDeliveryDaysAsc = false;
        this.sortByCreationDateAsc = false;
        this.sortByCreationByAsc = false;

        if (ascendingOrder) {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.description! < special2.description!) return -1;
            if (special1.description! > special2.description!) return 1;
            return 0;
          });
        } else {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.description! < special2.description!) return 1;
            if (special1.description! > special2.description!) return -1;
            return 0;
          });
        }
        break;
      }
      case 'class2': {
        this.SortBySkuAsc = false;
        this.sortByDescriptionAsc = false;
        this.sortByClass2Asc = ascendingOrder;
        this.sortBySupplierSkuAsc = false;
        this.sortByOrderUnitAsc = false;
        this.sortBySupplierPriceAsc = false;
        this.sortBySalesPriceAsc = false;
        this.sortByDeliveryDaysAsc = false;
        this.sortByCreationDateAsc = false;
        this.sortByCreationByAsc = false;

        if (ascendingOrder) {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.class2! < special2.class2!) return -1;
            if (special1.class2! > special2.class2!) return 1;
            return 0;
          });
        } else {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.class2! < special2.class2!) return 1;
            if (special1.class2! > special2.class2!) return -1;
            return 0;
          });
        }
        break;
      }
      case 'supplierSku': {
        this.SortBySkuAsc = false;
        this.sortByDescriptionAsc = false;
        this.sortByClass2Asc = false;
        this.sortBySupplierSkuAsc = ascendingOrder;
        this.sortByOrderUnitAsc = false;
        this.sortBySupplierPriceAsc = false;
        this.sortBySalesPriceAsc = false;
        this.sortByDeliveryDaysAsc = false;
        this.sortByCreationDateAsc = false;
        this.sortByCreationByAsc = false;

        if (ascendingOrder) {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.supplierSKU < special2.supplierSKU) return -1;
            if (special1.supplierSKU > special2.supplierSKU) return 1;
            return 0;
          });
        } else {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.supplierSKU < special2.supplierSKU) return 1;
            if (special1.supplierSKU > special2.supplierSKU) return -1;
            return 0;
          });
        }
        break;
      }
      case 'orderUnit': {
        this.SortBySkuAsc = false;
        this.sortByDescriptionAsc = false;
        this.sortByClass2Asc = false;
        this.sortBySupplierSkuAsc = false;
        this.sortByOrderUnitAsc = ascendingOrder;
        this.sortBySupplierPriceAsc = false;
        this.sortBySalesPriceAsc = false;
        this.sortByDeliveryDaysAsc = false;
        this.sortByCreationDateAsc = false;
        this.sortByCreationByAsc = false;

        if (ascendingOrder) {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.orderUnit < special2.orderUnit) return -1;
            if (special1.orderUnit > special2.orderUnit) return 1;
            return 0;
          });
        } else {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.orderUnit < special2.orderUnit) return 1;
            if (special1.orderUnit > special2.orderUnit) return -1;
            return 0;
          });
        }
        break;
      }
      case 'supplierPrice': {
        this.SortBySkuAsc = false;
        this.sortByDescriptionAsc = false;
        this.sortByClass2Asc = false;
        this.sortBySupplierSkuAsc = false;
        this.sortByOrderUnitAsc = false;
        this.sortBySupplierPriceAsc = ascendingOrder;
        this.sortBySalesPriceAsc = false;
        this.sortByDeliveryDaysAsc = false;
        this.sortByCreationDateAsc = false;
        this.sortByCreationByAsc = false;

        if (ascendingOrder) {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.supplierPrice! < special2.supplierPrice!) return -1;
            if (special1.supplierPrice! > special2.supplierPrice!) return 1;
            return 0;
          });
        } else {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.supplierPrice! < special2.supplierPrice!) return 1;
            if (special1.supplierPrice! > special2.supplierPrice!) return -1;
            return 0;
          });
        }
        break;
      }
      case 'salesPrice': {
        this.SortBySkuAsc = false;
        this.sortBySupplierSkuAsc = false;
        this.sortByDescriptionAsc = false;
        this.sortBySupplierSkuAsc = false;
        this.sortByOrderUnitAsc = false;
        this.sortBySupplierPriceAsc = false;
        this.sortBySalesPriceAsc = ascendingOrder;
        this.sortByDeliveryDaysAsc = false;
        this.sortByCreationDateAsc = false;
        this.sortByCreationByAsc = false;

        if (ascendingOrder) {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.salesPrice! < special2.salesPrice!) return -1;
            if (special1.salesPrice! > special2.salesPrice!) return 1;
            return 0;
          });
        } else {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.salesPrice! < special2.salesPrice!) return 1;
            if (special1.salesPrice! > special2.salesPrice!) return -1;
            return 0;
          });
        }
        break;
      }
      case 'deliveryDays': {
        this.SortBySkuAsc = false;
        this.sortBySupplierSkuAsc = false;
        this.sortByDescriptionAsc = false;
        this.sortBySupplierSkuAsc = false;
        this.sortByOrderUnitAsc = false;
        this.sortBySupplierPriceAsc = false;
        this.sortBySalesPriceAsc = false;
        this.sortByDeliveryDaysAsc = ascendingOrder;
        this.sortByCreationDateAsc = false;
        this.sortByCreationByAsc = false;

        if (ascendingOrder) {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.deliveryDays! < special2.deliveryDays!) return -1;
            if (special1.deliveryDays! > special2.deliveryDays!) return 1;
            return 0;
          });
        } else {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.deliveryDays! < special2.deliveryDays!) return 1;
            if (special1.deliveryDays! > special2.deliveryDays!) return -1;
            return 0;
          });
        }
        break;
      }
      case 'creationBy': {
        this.SortBySkuAsc = false;
        this.sortBySupplierSkuAsc = false;
        this.sortByDescriptionAsc = false;
        this.sortByOrderUnitAsc = false;
        this.sortBySupplierPriceAsc = false;
        this.sortBySalesPriceAsc = false;
        this.sortByDeliveryDaysAsc = false;
        this.sortByCreationByAsc = ascendingOrder;
        this.sortByCreationDateAsc = false;

        if (ascendingOrder) {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.creationBy < special2.creationBy) return -1;
            if (special1.creationBy > special2.creationBy) return 1;
            return 0;
          });
        } else {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.creationBy < special2.creationBy) return 1;
            if (special1.creationBy > special2.creationBy) return -1;
            return 0;
          });
        }
        break;
      }
      case 'creationDate': {
        this.SortBySkuAsc = false;
        this.sortByDescriptionAsc = false;
        this.sortByClass2Asc = false;
        this.sortBySupplierSkuAsc = false;
        this.sortByOrderUnitAsc = false;
        this.sortBySupplierPriceAsc = false;
        this.sortBySalesPriceAsc = false;
        this.sortByDeliveryDaysAsc = false;
        this.sortByCreationByAsc = false;
        this.sortByCreationDateAsc = ascendingOrder;

        if (ascendingOrder) {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.creationDate! < special2.creationDate!) return -1;
            if (special1.creationDate! > special2.creationDate!) return 1;
            return 0;
          });
        } else {
          this.specials = this.specials.sort((special1, special2) => {
            if (special1.creationDate! < special2.creationDate!) return 1;
            if (special1.creationDate! > special2.creationDate!) return -1;
            return 0;
          });
        }
        break;
      }

      default: {
        //statements;
        break;
      }
    }
    this.updateSortingHighlight(`${field}${ascendingOrder ? 'Asc' : 'Desc'}`);
  }

  updateSortingHighlight(highlightElement: string) {
    this.sortIcons.forEach((element: ElementRef) => {
      if (element.nativeElement.id == highlightElement) {
        this.renderer.addClass(element.nativeElement, 'highlight');
      } else {
        this.renderer.removeClass(element.nativeElement, 'highlight');
      }
    });
  }

  onSearchTextChange() {
    this.page = 1;
  }
}
